module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rightContent"
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    attrs: {
      "id": "footerBar"
    }
  }, [_c('div', {
    staticClass: "shwogbar"
  }, [_vm._v(_vm._s(_vm.thisTagid + 1) + "/" + _vm._s(_vm.thisQlen))]), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [(_vm.thisTagid + 1 < _vm.thisQlen) ? _c('span', {
    staticClass: "blue",
    style: ('width:' + parseInt((_vm.thisTagid) * 100 / _vm.thisQlen) + '%')
  }, [_c('span')]) : _vm._e(), _vm._v(" "), (_vm.thisTagid + 1 == _vm.thisQlen) ? _c('span', {
    staticClass: "blue",
    style: ('width:' + 100 + '%')
  }, [_c('span')]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "assess question"
  }, [_c('header', [_c('h2', [_c('a', [_vm._v("$")]), _vm._v(_vm._s(_vm.scaledatas.SCALENAME))]), _vm._v(" "), (_vm.czsm != '') ? [_c('button', {
    attrs: {
      "type": "button",
      "id": "actBtn"
    },
    on: {
      "click": function($event) {
        _vm.actShow = !_vm.actShow
      }
    }
  }, [_vm._v("操作说明")])] : _vm._e()], 2), _vm._v(" "), _c('main', {
    attrs: {
      "id": "qMain"
    }
  }, [_c('form', {
    attrs: {
      "method": "post",
      "id": "theform",
      "action": _vm.accessendurl
    }
  }, [_c('div', {
    attrs: {
      "id": "memo"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "qlist"
    }
  }, [_c('div', {
    staticClass: "questions step"
  }, [_vm._l((_vm.questions), function(q) {
    return [_c('div', {
      staticClass: "content clearfix",
      class: {
        'on': _vm.thisQid == q['ID']
      }
    }, [_c('div', {
      attrs: {
        "id": "actions"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.actShow),
        expression: "actShow"
      }],
      staticClass: "showBox",
      attrs: {
        "id": 'memo' + q['ID']
      }
    }, [_vm._v(_vm._s(q['MEMO']))])]), _vm._v(" "), (q['TESTFACTORID'] != 1) ? [_c('div', {
      staticClass: "sontag"
    }, [_vm._v(_vm._s(q['ptestfactor']['name'])), _c('span', [(q['ctestfactor'] != '') ? _c('em', [_vm._v(_vm._s(q['ctestfactor']['name']) + "-")]) : _vm._e(), (q['ctestfactor'] != '') ? _c('em', [_vm._v("总分" + _vm._s(q['ctestfactor']['score']))]) : _c('em', [_vm._v("总分" + _vm._s(q['ptestfactor']['score']))])])])] : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(q['TITLE']))]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(q['CONTENT'])
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "anstag",
      staticStyle: {
        "font-size": "28px",
        "clear": "both"
      }
    }, [_vm._v("答案:")]), _vm._v(" "), (q['QUESTYPE'] == '2') ? _c('div', {
      staticClass: "ansbar"
    }, [_vm._l((q.answers), function(answer, dataobj) {
      return [_c('label', {
        staticClass: "radio"
      }, [_c('input', {
        staticStyle: {
          "border": "1px solid #ccc",
          "border-radius": "1px"
        },
        attrs: {
          "name": 'questions[' + q['ID'] + '][' + dataobj + ']',
          "type": "number",
          "oninput": "if(value<0){value = 0;}"
        }
      }), _vm._v(" "), _c('em', [_vm._v(_vm._s(answer['ANSWERCONTENT']))])])]
    })], 2) : _c('div', {
      staticClass: "ansbar"
    }, [(q['ISMULTISELECT'] == '1') ? _c('div', [_vm._l((q.answers), function(answer, dataobj) {
      return [_c('label', {
        staticClass: "radio"
      }, [_c('input', {
        staticStyle: {
          "border-radius": "0"
        },
        attrs: {
          "name": 'questions[' + q['ID'] + '][' + dataobj + ']',
          "type": "checkbox"
        },
        domProps: {
          "value": answer['ID']
        }
      }), _vm._v(" "), _c('em', [_vm._v(_vm._s(answer['ANSWERCONTENT']))])])]
    })], 2) : _c('div', {
      staticClass: "szgdsb"
    }, [_vm._l((q.answers), function(answer, dataobj) {
      return [_c('label', {
        staticClass: "radio"
      }, [_c('input', {
        attrs: {
          "name": 'questions[' + q['ID'] + '][]',
          "type": "radio"
        },
        domProps: {
          "value": answer['ID']
        }
      }), _vm._v(" "), _c('em', [_vm._v(_vm._s(answer['ANSWERCONTENT']))])])]
    })], 2)]), _vm._v(" "), _c('div', {
      attrs: {
        "id": "rightans"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ansShow),
        expression: "ansShow"
      }],
      staticClass: "showBox",
      attrs: {
        "id": 'remark' + q['ID']
      }
    }, [_vm._v(_vm._s(q['REMARK']))])])], 2)]
  })], 2)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "progress"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "changeQ"
    }
  }, [(_vm.ckda != '') ? [_c('button', {
    attrs: {
      "type": "button",
      "id": "ckBtn"
    },
    on: {
      "click": function($event) {
        _vm.ansShow = !_vm.ansShow
      }
    }
  }, [_vm._v("查看正确答案")])] : _vm._e(), _vm._v(" "), _c('button', {
    class: {
      'onBtn': _vm.prevBtn == 0
    },
    attrs: {
      "id": "btnP",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.prevQ()
      }
    }
  }, [_vm._v("上一题")]), _vm._v(" "), _c('button', {
    class: {
      'onBtn': _vm.nextBtn == 0
    },
    attrs: {
      "id": "btnN",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.nextQ()
      }
    }
  }, [_vm._v("下一题")]), _vm._v(" "), _c('button', {
    class: {
      'onBtn': _vm.subBtn == 0
    },
    attrs: {
      "id": "btnsubmit",
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.subQ()
      }
    }
  }, [_vm._v("提交")])], 2), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "nowqid"
    },
    domProps: {
      "value": _vm.thisQid
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": _vm.thisTagid
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": _vm.thisQlen
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": parseInt((_vm.thisTagid - 1) * 100 / _vm.thisQlen)
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "break",
      "value": "0"
    }
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBox),
      expression: "showBox"
    }],
    staticClass: "showBox"
  }, [_c('div', {
    staticClass: "bacMask"
  }), _vm._v(" "), _c('figure', {
    staticClass: "middleContentConform"
  }, [_c('figcaption', [_vm._v("您本题还没有做！")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.showBox = false
      }
    }
  }, [_vm._v("确定")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.endAlert),
      expression: "endAlert"
    }],
    staticClass: "end-alert"
  }, [_c('div', {
    staticClass: "bacMask"
  }), _vm._v(" "), _c('figure', {
    staticClass: "middleContentConform"
  }, [_c('figcaption', [_vm._v("连续两串数字复述错误，测评结束！")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.endAlertFunc()
      }
    }
  }, [_vm._v("确定")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.printImgAlert),
      expression: "printImgAlert"
    }],
    staticClass: "print-img-alert"
  }, [_c('div', {
    staticClass: "bacMask"
  }), _vm._v(" "), _c('figure', {
    staticClass: "middleContentImg"
  }, [_c('figcaption', [_c('img', {
    attrs: {
      "src": _vm.printImgSrc
    }
  })]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.printImgAlert = false
      }
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('button', {
    staticClass: "can-print",
    on: {
      "click": function($event) {
        _vm.printImg(encodeURIComponent(_vm.printImgSrc))
      }
    }
  }, [_vm._v("打印")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showImgTitle),
      expression: "showImgTitle"
    }],
    attrs: {
      "id": "mouse-in-img"
    }
  }, [_c('span', [_vm._v("点击放大图片，并支持打印")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-15c66c3e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/service/evaluation/startEval.vue
// module id = 954
// module chunks = 2